module.exports = __webpack_public_path__ + "img/craftBannerCarport.5f53347.jpg";